export const API_HOST =
  process.env.ENVIRONMENT === "production"
    ? "app.getclockwise.com"
    : process.env.ENVIRONMENT === "staging"
    ? "app.staging.getclockwise.com"
    : "localhost:8080";

// For now, only staging will use the app sub-domain, others will derive from context like previous
export const API_URL =
  process.env.ENVIRONMENT === "production"
    ? "https://app.getclockwise.com"
    : process.env.ENVIRONMENT === "staging"
    ? "https://app.staging.getclockwise.com"
    : "";

export const SOCKET_URL =
  process.env.ENVIRONMENT === "production"
    ? "wss://app.getclockwise.com"
    : process.env.ENVIRONMENT === "staging"
    ? "wss://app.staging.getclockwise.com"
    : "wss://localhost:8080";
